import { Helmet } from "react-helmet";
import React, { Component } from "react";
import { Form, Col, Button } from "react-bootstrap";
import "../../styles/depots/depots.scss";
import { apiHost } from "../../api/apiClient";
import axios from "axios";
import DepotMap  from "../maps/depotMap";
import HtmlContent from "../commoncomponents/htmlContent";
import Layout from "../../Layout/layout";
import { setLoadingPage, setErrorMessage } from "../../reducers/actions";
import { connect } from "react-redux";
import { searchSuggestionAPI, GeoCodeAPI } from "../../utils/mapapi";
class CreateZone extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customers: [],
      depots: [],
      customerId: "",
      customerName: "",
      depotId: "default",
      depotError: false,
      name: "",
      address: "",
      duration: "",
      timeZoneArr: [],
      description: "",
      error: false,
      timeZoneId: "",
      type: "",
      status: "Active",
      suggestions: [],
      suggestionVisibility: false,
      searchText: "",
      lat: "",
      lng: "",
      customerError: false,
      nameError: false,
      descriptionError: false,
      timeZoneError: false,
      typeError: false,
      statusError:false,
      mapOverlayError: false,
      mapOverLay: "",
      privatePoi: false,
    };
    this.circleLat = "";
    this.circleLng = "";
    this.circleRad = "";
    this.polygonArr = [];
    this.rectLat1 = "";
    this.rectLat2 = "";
    this.rectLng1 = "";
    this.rectLng2 = "";
    this.type = "";
  }
  async componentDidMount() {
    this.handleArrRecreation();
    if(localStorage.getItem('role') === "SystemAdmin"){
      this.getCustomers();
    }
    this.getTimeZone();
  }

  getCustomers = async () => {
    this.props.setLoadingPageAction(true);

    try {
      const response = await axios.get(
        `${apiHost}/api/Customer/GetAllCustomers`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (response.status == "200") {
        this.setState({
          customers: response.data,
          customerId: response.data[0].id,
          customerName: response.data[0].name,
        });
        this.getDepotList(response.data[0].id);
      }
      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  };
  getDepotList = async (id) => {
    this.props.setLoadingPageAction(true);

    try {
      const response = await axios.get(
        `${apiHost}/api/Depots/DepotByCustomerId/${id}`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (response.status == "200") {
        this.setState({ depots: response.data });
      }
      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  getTimeZone = async () => {
    this.props.setLoadingPageAction(true);

    try {
      const response = await axios.get(
        `${apiHost}/api/Customer/GetAllTimeZone`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (response.status == "200") {
        this.setState({ timeZoneArr: response.data });
      }
      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  handleTimeZone = (evt) => {
    if (evt.target.value == "") {
      this.setState({ timeZoneError: true });
    } else {
      this.setState({ nameError: false });
    }
    this.state.timeZoneArr.forEach((time) => {
      if (time.timeZoneCity == evt.target.value) {
        this.setState({ timeZoneId: time.timeZonesId });
      }
    });
  };

  handleType = (evt) => {
    console.log("sj evt",evt.target.value);
    if (evt.target.value == "") {
      this.setState({ typeError: true });
    } else {
        this.setState({ typeError : false });
    }

    this.setState({ type: evt.target.value, status: evt.target.value });
    };

    handleStatus = (evt) => {
        console.log("sj evt", evt.target.value);
        if (evt.target.value == "") {
            this.setState({ statusError: true });
        } else {
            this.setState({ statusError: false });
        }

        this.setState({status: evt.target.value });
    };

  // handleCancel = () =>{
  //   this.props.history.push("/customers");
  // }

  handleCustomer = (evt) => {
    if (evt.target.value == "" && localStorage.getItem('role') === "SystemAdmin") {
      this.setState({ customerError: true });
    } else {
      this.setState({ nameError: false });
    }
    this.state.customers.forEach((customer) => {
      if (customer.name == evt.target.value) {
        this.setState({ customerId: customer.id, customerName: customer.name });
        this.getDepotList(customer.id);
      }
    });
  };
  handleDepot = (e) => {
    if (e.target.value == "default") {
      this.setState({ depotError: true });
    }

    this.setState({ depotId: e.target.value, depotError: false });
    console.log(e.target.value);
  };

  handleName = (evt) => {
    if (evt.target.value == "") {
      this.setState({ nameError: true });
    } else {
      this.setState({ nameError: false });
    }
    this.setState({ name: evt.target.value });
  };

  handleDescription = (evt) => {
    this.setState({ description: evt.target.value });
  };

  handleArrCreation = (data) => {
    var i;
    for (i = 0; i < data.length; i++) {
      if (data[i] == 0) data.splice(i, 1);
    }
    var requiredArr = [];
    for (i = 0; i < data.length; i = i + 2) {
      const coordinateObj = {
        lat: data[i],
        lng: data[i + 1],
      };
      requiredArr.push(coordinateObj);
    }

    return requiredArr;
  };

  handleArrRecreation = (data) => {
    var dataNew = [
      {
        lat: -22.67253064091629,
        lng: 127.47044921875,
      },
      {
        lat: -22.87453064091629,
        lng: 127.33044921875,
      },
      {
        lat: -23.052530640916288,
        lng: 127.52744921875001,
      },
      {
        lat: -22.98153064091629,
        lng: 127.74844921875001,
      },
      {
        lat: -22.74253064091629,
        lng: 127.74844921875001,
      },
    ];

    var requiredArr = [];
    dataNew.forEach((element) => {
      requiredArr.push(element.lat);
      requiredArr.push(element.lng);
      requiredArr.push(0);
    });

    return requiredArr;
  };

  handleCircleCreate = (data) => {
    this.circleLat = data.lat;
    this.circleLng = data.lng;
    this.circleRad = data.rad;
    this.type = "circle";

    this.createMapOverLay();
  };

  handlePolygonCreate = (data) => {
    this.polygonArr = data;
    this.type = "polygon";
    this.createMapOverLay();
  };

  handleRectangleCreate = (data) => {
    this.type = "rectangle";
    this.rectLat1 = data.lat1;
    this.rectLat2 = data.lat2;
    this.rectLng1 = data.lng1;
    this.rectLng2 = data.lng2;
    this.createMapOverLay();
  };

  createMapOverLay = (polygonData) => {
    var mapOverlayObj = {};

    switch (this.type) {
      case "circle":
        mapOverlayObj.type = this.type;
        mapOverlayObj.lat = this.circleLat;
        mapOverlayObj.lng = this.circleLng;
        mapOverlayObj.rad = this.circleRad;

        this.setState({ mapOverLay: JSON.stringify(mapOverlayObj) });

        break;
      case "polygon":
        mapOverlayObj.type = this.type;
        mapOverlayObj.arr = this.polygonArr;

        this.setState({ mapOverLay: JSON.stringify(mapOverlayObj) });

        break;
      case "rectangle":
        mapOverlayObj.type = this.type;
        mapOverlayObj.north = this.rectLat1;
        mapOverlayObj.south = this.rectLat2;
        mapOverlayObj.west = this.rectLng1;
        mapOverlayObj.east = this.rectLng2;

        this.setState({ mapOverLay: JSON.stringify(mapOverlayObj) });
        break;
      default: break;
    }
  };

  handleAddress = (e) => {
    this.setState({ address: e.target.value });
  };
  handleDuration = (e) => {
    this.setState({ duration: e.target.value });
  };

  handlePrivatePoi = (e) => {
    this.setState({ privatePoi: e.target.checked });
  };

  handleCreate = async () => {
    const { name, description, customerId } = this.state;
    const obb = {
      CustomerId: customerId,
      Name: name,
      Address: this.state.address,
      Duration: this.state.duration,
      Description: description,
      Status: this.state.status == "Active" ? 1 : 0,
      Private: this.state.privatePoi,
    };

    var mapOverlayObj = {};
    switch (this.type) {
      case "circle":
        mapOverlayObj.type = this.type;
        mapOverlayObj.lat = this.circleLat;
        mapOverlayObj.lng = this.circleLng;
        mapOverlayObj.rad = this.circleRad;

        obb.Overlay = JSON.stringify(mapOverlayObj);
        console.log("MapOverlay from circ", obb.Overlay);
        break;
      case "polygon":
        mapOverlayObj.type = this.type;
        mapOverlayObj.arr = this.handleArrCreation(this.polygonArr);

        obb.Overlay = JSON.stringify(mapOverlayObj);
        console.log("MapOverlay from poly", obb.Overlay);
        break;
      case "rectangle":
        mapOverlayObj.type = this.type;
        mapOverlayObj.north = this.rectLat1;
        mapOverlayObj.south = this.rectLat2;
        mapOverlayObj.west = this.rectLng1;
        mapOverlayObj.east = this.rectLng2;

        obb.Overlay = JSON.stringify(mapOverlayObj);
        console.log("MapOverlay from rect", obb.Overlay);
        break;
      default: break;
    }

    this.validationCheck(obb.Overlay);
    
    if (name  && obb.Overlay) {
      this.props.setLoadingPageAction(true);

      try {
        const response = await axios.post(
          `${apiHost}/api/POI/POIRegister`,
          obb,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        );

        if (response.status == "200") {
          // this.props.history.push("/zones");
          this.props.history.goBack();
        }
        this.props.setLoadingPageAction(false);
      } catch (e) {
        if (e.response.status == "401") {
          this.props.history.push("/login");
        } else {
          this.props.setErrorMessageAction(`${e}`);
        }
        this.props.setLoadingPageAction(false);

        console.log(`😱 Axios request failed: ${e}`);
        this.setState({ error_authorisation: true });
      }
    } else {
      this.setState({ error: true });
      setTimeout(() => {
        this.setState({ error: false });
      }, 3000);
    }
  };

  validationCheck = (obj) => {
    console.log("sj obj",obj);
    if (!this.state.name) {
      this.setState({ nameError: true });
    }
    // if(!this.state.description){
    //   this.setState({descriptionError:true})
    // }
    if (!this.state.customerId && localStorage.getItem('role') === "SystemAdmin") {
      this.setState({ customerError: true });
    }
    // if (this.state.depotId == "default") {
    //   this.setState({ depotError: true });
    // }
    if (!this.state.type) {
      this.setState({ typeError: true });
    }
    if (!this.state.status) {
        this.setState({ statusError: true });
    }
    // if (!this.state.timeZoneId) {
    //   this.setState({ timeZoneError: true });
    // }
    if (!obj) {
      this.setState({ mapOverlayError: true });
    }
  };

  handleBack = () => {
    //this.props.history.push("/zones");
    this.props.history.goBack();
  };

  // Map search and suggestions starts here
  handleLocationChange = (searchText) => {
    this.setState({ searchText });
    this.handleSearchSuggestion(searchText);
  };

  handleSearch = async () => {
    try {
      console.log("searec1", this.state.searchText);
        const { lat, lng } = await GeoCodeAPI(this.state.searchText);
        if (lat !== 0 && lng !== 0) {
        this.setState({
            lat: lat,
            lng: lng,
        });
      } else {
        this.setState({ errorSearch: true });
        setTimeout(() => {
          this.setState({ errorSearch: false });
        }, 1000);
      }
    } catch (e) {
      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  handleSearchSuggestion = async (query) => {
    if (query != "") {
      this.setState({ suggestionVisibility: false });
    }
    this.setState({ suggestionVisibility: true });
      try {
          const items = await searchSuggestionAPI(query);
          this.setState({ suggestions: items });
      } catch (e) {
          console.log(e);
      }
  };
  handleKeyPress = (event) => {
    if (event.key === "Enter") {
      console.log("enter press here! ", event.target.value);
      this.handleSuggestionClick(event.target.value);
    }
  };
  handleSuggestionClick = async (place) => {
    var nwlocation = place.replace("<b>", "");
    var location = nwlocation.replace("</b>", "");

    this.setState({ searchText: location, suggestionVisibility: false });
    try {
      console.log("searecyy", location);
        const { lat, lng } = await GeoCodeAPI(location);
        if (lat !== 0 && lng !== 0) {
        this.setState({
            lat: lat,
            lng: lng,
        });
      } else {
        this.setState({ errorSearch: true });
        setTimeout(() => {
          this.setState({ errorSearch: false });
        }, 1000);
      }
    } catch (e) {
      console.log(`😱 Axios request failed: ${e}`);
    }
  };
  // Map search and suggestions ends here

  render() {
    const {
      customers,
      customerName,
      name,
      lat,
      lng,
      customerError,
      nameError,
      descriptionError,
      mapOverlayError,
      statusError,
    } = this.state;
    return (
      <React.Fragment>
        <Layout>
          <Helmet>
            <title>Create POI Zone </title>
          </Helmet>
          <div className="contentBody">
            <div className="contentWrapper depot-record-page">
              <div className="depot-record-header">
                <div>
                  <p className="depot-record-kicker">POI zone creator</p>
                  <h2>{name || "Create POI Zone"}</h2>
                  <div className="depot-record-subtitle">
                    <span>{customerName || "Select customer"}</span>
                    <span className={this.state.status === "Active" ? "record-badge-active" : "record-badge-disabled"}>
                      {this.state.status === "Active" ? "Active" : "Disabled"}
                    </span>
                    <span>{this.type ? `${this.type.charAt(0).toUpperCase()}${this.type.slice(1)} overlay` : "Select overlay"}</span>
                  </div>
                </div>
                <div className="depot-record-actions">
                  <Button variant="light" onClick={this.handleBack}>
                    Back to List
                  </Button>
                  <Button variant="primary" onClick={this.handleCreate}>
                    Create POI Zone
                  </Button>
                </div>
              </div>

              <div className="depot-edit-layout">
                <Form className="depot-edit-form-modern">
                  <section className="depot-edit-section">
                    <div className="depot-edit-section-title">
                      <h3>POI Zone Details</h3>
                      <p>Customer ownership, naming, address and operational defaults.</p>
                    </div>
                    <div className={`poi-note poi-visibility-banner ${this.state.privatePoi ? "private" : "public"}`}>
                      <div>
                        <span className={`poi-visibility-badge ${this.state.privatePoi ? "private" : "public"}`}>
                          {this.state.privatePoi ? "Private" : "Public"}
                        </span>
                        <p>
                          {this.state.privatePoi
                            ? "This POI zone is private and visible only to your account."
                            : "POI zones are public and visible to all users across your organisation."}
                        </p>
                      </div>
                      <Form.Check
                        custom
                        type="switch"
                        id="createPoiPrivate"
                        className="poi-visibility-switch"
                        label="Private POI Zone"
                        checked={this.state.privatePoi}
                        onChange={this.handlePrivatePoi}
                      />
                    </div>
                    <div className="depot-edit-grid">
                      <Form.Group className="depot-form-field" controlId="createPoiName">
                        <Form.Label>Name</Form.Label>
                        <Form.Control onChange={this.handleName} type="text" value={name} />
                        {nameError && (
                          <p className="depot-field-error">The Name field is required.</p>
                        )}
                      </Form.Group>

                      <Form.Group className="depot-form-field" controlId="createPoiDuration">
                        <Form.Label>Duration (minutes)</Form.Label>
                        <Form.Control onChange={this.handleDuration} type="number" value={this.state.duration} />
                        <p className="depot-help-text">Suggested stop duration for Run Sheet and POI zone visit reporting.</p>
                      </Form.Group>

                      {localStorage.getItem("role") === "SystemAdmin" && (
                        <Form.Group className="depot-form-field" controlId="createPoiCustomer">
                          <Form.Label>Customer</Form.Label>
                          <Form.Control as="select" onChange={this.handleCustomer}>
                            {customers.map((customer, index) => (
                              <option key={index}>{customer.name}</option>
                            ))}
                          </Form.Control>
                          {customerError && (
                            <p className="depot-field-error">The Customer field is required.</p>
                          )}
                        </Form.Group>
                      )}

                      <Form.Group className="depot-form-field" controlId="createPoiStatus">
                        <Form.Label>Status</Form.Label>
                        <Form.Control as="select" onChange={this.handleStatus} value={this.state.status}>
                          <option>Active</option>
                          <option>Disable</option>
                        </Form.Control>
                        {statusError && (
                          <p className="depot-field-error">The Status field is required.</p>
                        )}
                      </Form.Group>

                      <Form.Group className="depot-form-field depot-edit-wide" controlId="createPoiAddress">
                        <Form.Label>Address</Form.Label>
                        <Form.Control onChange={this.handleAddress} type="text" value={this.state.address} />
                      </Form.Group>

                      <Form.Group className="depot-form-field depot-edit-wide" controlId="createPoiDescription">
                        <Form.Label>Description</Form.Label>
                        <Form.Control as="textarea" rows="4" onChange={this.handleDescription} value={this.state.description} />
                        {descriptionError && (
                          <p className="depot-field-error">The Description field is required.</p>
                        )}
                      </Form.Group>
                    </div>
                  </section>

                  <section className="depot-edit-section depot-map-section">
                    <div className="depot-map-card-header">
                      <div>
                        <p className="depot-record-kicker">Map overlay</p>
                        <h3>POI zone boundary</h3>
                        <p>Search for a location, then draw the POI zone boundary on the map.</p>
                      </div>
                      {mapOverlayError && (
                        <p className="depot-field-error">The Map field is required.</p>
                      )}
                    </div>
                    <div className="depot-record-card depot-map-card">
                      <div className="containerMapDepot">
                        <DepotMap
                          onCircleCreate={this.handleCircleCreate}
                          onPolygonCreate={this.handlePolygonCreate}
                          onRectangleCreate={this.handleRectangleCreate}
                          lat={lat}
                          lng={lng}
                          resetzoomLevelOnSelect={true}
                        />
                        <div className="overlaySearch">
                          <Col sm="12" className="inputSuggestions">
                            <Form.Control
                              value={this.state.searchText}
                              onChange={(e) => this.handleLocationChange(e.target.value)}
                              onKeyPress={(e) => this.handleKeyPress(e)}
                              autoComplete="off"
                              type="text"
                              placeholder="Search location"
                            />
                            {this.state.suggestionVisibility && (
                              <ul>
                                {this.state.suggestions &&
                                  this.state.suggestions.map((item) => (
                                    <li
                                      key={item.address.label}
                                      onClick={() => this.handleSuggestionClick(item.address.label)}
                                    >
                                      <HtmlContent html={item.address.label} />
                                    </li>
                                  ))}
                              </ul>
                            )}
                          </Col>
                        </div>
                      </div>
                    </div>
                  </section>

                  {this.state.error && (
                    <p className="error-text depot-save-error">
                      Please fill all the Required fields
                    </p>
                  )}

                  <div className="depot-record-actions depot-edit-actions">
                    <Button variant="light" onClick={this.handleBack}>
                      Back to List
                    </Button>
                    <Button variant="primary" onClick={this.handleCreate}>
                      Create POI Zone
                    </Button>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </Layout>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateZone);
